import { Text } from '@mantine/core';

export const TermsAndPrivacy = () => (
  <Text size="xs" c="gray.6" ta="center">
    By continuing, you agree to our {/* TODO: Add Terms of Service link when available */}
    {/* <Text
      component="a"
      href="https://afternoon.co.uk/terms-of-service"
      target="_blank"
      rel="noopener noreferrer"
      inherit
      c="dark"
      td="underline"
    >
      Terms of Service
    </Text>{' '}
    and{' '} */}
    <Text
      component="a"
      href="https://afternoon.co.uk/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      inherit
      c="dark"
      td="underline"
    >
      Privacy Policy
    </Text>
  </Text>
);
